import { useAutoneTranslation } from '@autone/translations';
import {
  createColumnLoadingGuards,
  DataTableCellContent,
  DataTableCellDate,
  DataTableCellTitle,
  type DataTableLoadingObject,
} from '@autone/ui';
import { type ColumnHelper } from '@tanstack/react-table';

import { type APP_NAME } from '../../../../consts';

const COLUMN_ID = 'assorted_end_date' as const;

export type ScheduledEndDateColumnId = typeof COLUMN_ID;

interface ScheduledEndDateFields {
  assorted_end_date: string | null;
}

const { columnCellGuard, accessorFnGuard } =
  createColumnLoadingGuards<ScheduledEndDateFields>();

export const createScheduledEndDateColumn = <
  T extends ScheduledEndDateFields | DataTableLoadingObject,
>(
  columnHelper: ColumnHelper<T>,
) =>
  columnHelper.accessor(
    accessorFnGuard((row) => row.assorted_end_date),
    {
      id: COLUMN_ID,
      size: 200,
      header: function LastScheduledEndDateHeader() {
        const { t } = useAutoneTranslation<typeof APP_NAME>();

        return (
          <DataTableCellContent align="right">
            <DataTableCellTitle className="uppercase font-medium whitespace-normal">
              {t('table-columns.scheduled-assortment-end')}
            </DataTableCellTitle>
          </DataTableCellContent>
        );
      },
      cell: (ctx) =>
        columnCellGuard({
          ctx,
          renderCell: function LastScheduledEndDateCell({ getValue }) {
            return (
              <DataTableCellContent align="right">
                <DataTableCellTitle>
                  <DataTableCellDate value={getValue()} />
                </DataTableCellTitle>
              </DataTableCellContent>
            );
          },
        }),
    },
  );
